import { isAuctionStyleEndVehicle } from 'components/card/Buyers/Helpers';
import { BID_SALE_PHASE } from 'constants/bidSale';
import dayjs from 'dayjs';
import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';

const getDealWorkingOfferStatus = ({ currentUserTopOfferer, vehicle }) => {
	const { phase, my_offer_amount } = vehicle;
	const isNegotiationPhase = phase === BID_SALE_PHASE.negotiation;
	const didUserAlreadyBid = Boolean(my_offer_amount);

	if (isNegotiationPhase) {
		return getNegotiationPhaseStatus({ currentUserTopOfferer, didUserAlreadyBid, vehicle });
	}

	return getNonNegotiationPhaseStatus({ currentUserTopOfferer, vehicle });
};

export const getCounterOfferStatus = ({ my_offer_date, lowest_counter_date }) => {
	const sellerIsLastCounter = dayjs(lowest_counter_date).isAfter(my_offer_date);

	return {
		unifiedStatusType:
			sellerIsLastCounter ? MKT_STATUS_TYPE.sellerIsLastCounter : MKT_STATUS_TYPE.buyerIsLastCounter,
	};
};

const getNegotiationPhaseStatus = ({ currentUserTopOfferer, didUserAlreadyBid, vehicle }) => {
	const { lowest_counter_date } = vehicle;
	if (!currentUserTopOfferer) {
		return { unifiedStatusType: didUserAlreadyBid ? MKT_STATUS_TYPE.outbid : MKT_STATUS_TYPE.otherLeader };
	}

	const sellerCounterOffer = !!lowest_counter_date;

	if (sellerCounterOffer) {
		return getCounterOfferStatus(vehicle);
	}

	return { unifiedStatusType: MKT_STATUS_TYPE.buyerIsLastCounter };
};

const getNonNegotiationPhaseStatus = ({ currentUserTopOfferer, vehicle }) => {
	const { reserve_met, lowest_counter_date, acceptable_counter_offer_activity } = vehicle;
	if (currentUserTopOfferer) {
		const sellerCounterOffer = !!lowest_counter_date;

		if (sellerCounterOffer) {
			return getCounterOfferStatus(vehicle);
		}

		return { unifiedStatusType: MKT_STATUS_TYPE.buyerIsLastCounter };
	}

	if (isAuctionStyleEndVehicle(vehicle) && acceptable_counter_offer_activity) {
		return { unifiedStatusType: MKT_STATUS_TYPE.sellerIsLastCounter };
	}
	return {
		unifiedStatusType: reserve_met ? MKT_STATUS_TYPE.otherLeader : MKT_STATUS_TYPE.endedOnOffer,
	};
};

export default getDealWorkingOfferStatus;
